/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { SparseMatrixDependencies } from './dependenciesSparseMatrixClass.generated';
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createAdd } from '../../factoriesAny.js';
export var addDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  SparseMatrixDependencies: SparseMatrixDependencies,
  addScalarDependencies: addScalarDependencies,
  equalScalarDependencies: equalScalarDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createAdd: createAdd
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAdd.generated.js
// module id = 48
// module chunks = 0